"use client";

import { useState } from "react";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { Attribute } from "@/types/prodcatBaseTypes";
import styles from "./MeasurementsSideDrawer.module.scss";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

export type Props = {
  attributes: Attribute[];
};

export const MeasurementsSideDrawerUI = ({ attributes }: Props) => {
  const [open, setOpen] = useState(false);
  const defaultHelpText = "Height, Width, Depth";

  if (attributes.length < 1) {
    return null;
  }

  return (
    <>
      <ListItem
        label="Measurements"
        onClick={withSideDrawerAnalytics("Measurements", () => setOpen(true))}
        trailingIcon={<ArrowRight size="medium" />}
      />
      <Drawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading="Measurements"
      >
        <div data-testid="product:measurements:sidedrawer">
          <dl data-testid="product:measurements:list">
            {attributes.map((measurement) => (
              <div className={styles.measurement} key={measurement.key}>
                <dt
                  className={styles.measurementTitle}
                  data-testid="product:measurements:list:label"
                >
                  <span>{measurement.displayName}</span>
                  <ProductAttributeToolTip
                    helpText={measurement.helpText || defaultHelpText}
                    toolTipId={measurement.key}
                  />
                </dt>
                <dd
                  className={styles.measurementValue}
                  data-testid="product:measurements:list:value"
                >
                  {measurement.values[0]}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </Drawer>
    </>
  );
};

function ProductAttributeToolTip({
  helpText,
  toolTipId,
}: {
  helpText: string;
  toolTipId: string;
}) {
  return (
    <div
      data-testid="product:measurements:list:label:tooltip"
      className={styles.tooltipWrapper}
    >
      <Tooltip id={`tooltip-${toolTipId}`} icon verticalAnchor="top">
        {helpText}
      </Tooltip>
    </div>
  );
}
